import FishSearch from './FishSearch';

export default FishSearch;
